import React from 'react';
import styles from './LogoBar.css.js';
import logoImg from '../../assets/images/uninav-logo.png';

const LogoBar = () => {
    return (
        <div id='uniNav' style={styles.logoNav}>
            <img src={logoImg} style={styles.img} alt='logo-img'/>
        </div>
    )
};

export default LogoBar;